import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description SmilesUnhappy icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { SmilesUnhappy } from '@sravni/design-system-icons'
 *
 * <SmilesUnhappy />
 * ```
 */
var SmilesUnhappy = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "SmilesUnhappy", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.083 13.333S8.177 12.24 10 12.24c1.823 0 2.917 1.093 2.917 1.093", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.833 8.333c.33-.404.78-.633 1.25-.633.471 0 .909.23 1.25.633M11.667 8.333c.329-.404.779-.633 1.25-.633.47 0 .908.23 1.25.633", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { SmilesUnhappy };
//# sourceMappingURL=SmilesUnhappy.js.map
